import { useDispatch } from "react-redux";
import nodeinstance from "../../../../nodeInstance";
import { setAppError } from "../../../../store/userSlice";
import React, { useEffect, useState } from "react";

export default function EmployeeSalaryPackage({
  propData,
  quotationType,
  invoiceSummary,
  countdata,
}) {
  console.log(
    "nnnnnnnnnnnnnnnnnnnn.........",

    invoiceSummary
  );
  // const totalInvoiceRaised = invoiceSummary?.reduce((total, item) => {
  //   return total + (item.total_invoices_raised || 0);
  // }, 0);

  const totalInvoicePending = propData?.reduce((total, item) => {
    const quantity = parseInt(item.quantity);
    return total + (isNaN(quantity) ? 0 : quantity);
  }, 0);

  const dispatch = useDispatch();
  const token = localStorage.getItem("nodeToken");
  const row = [
    {
      id: 1,
      name: "YTC",
    },
  ];
  const tableHeading2_SUB = [
    {
      bgPrimary: "bg-pink-400",
      bgSecondary: "bg-pink-200",
    },
  ];
  const tableProperties2 = {
    colWidth: "w-48",
    colHeight: "h-[3rem]",
    itemHeight: "h-[3rem]",
  };

  const QuantityData = [
    {
      id: 1,
      Quantity: "YTC",
    },
  ];

  const tableHeading = [
    {
      rate_category_id: 1,
      title: "EMPLOYEE SALARY PACKAGE",
      bgPrimary: "bg-orange-400",
      bgSecondary: "bg-orange-200",
    },
  ];
  const tableProperties = {
    colWidth: "w-56",
    colHeight: "h-[2rem]",
    itemHeight: "h-[4rem]",
  };

  const [professions, setProfessions] = useState();
  const professionData = async () => {
    try {
      const response = await nodeinstance.get(
        "/dashboard/localTransfer/getProfessions",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        setProfessions(response?.data.data);
      }
    } catch (error) {
      dispatch(
        setAppError({
          msg: error.message,
        })
      );
    }
  };
  useEffect(() => {
    professionData();
  }, []);
  const containerStyle = {
    display: "flex",
    width: "100%",
    margin: 0,
    padding: 0,
  };

  const name1Style = {
    width: "65%",
    textAlign: "center",
    // padding: "10px",
    boxSizing: "border-box",
  };

  const nameHourStyle = {
    width: "75%",
    textAlign: "center",
    // padding: "10px",
    boxSizing: "border-box",
  };

  const name2Style = {
    width: "30%",
    textAlign: "center",
    padding: "15px",
    boxSizing: "border-box",
  };
  return (
    <>
      <div style={containerStyle} className="!uppercase">
        <div style={quotationType === "Cost Plus" ? name1Style : nameHourStyle}>
          <div
            className="flex flex-col w-full gap-1 my-2 overflow-x-scroll pt-8"
            style={propData?.length > 3 ? { height: "220px" } : {}}
          >
            <div className="flex">
              {row.map((section, sectionIndex) => (
                <div className="flex flex-col relative" key={sectionIndex}>
                  {sectionIndex == 0 && (
                    <>
                      <div
                        className={`w-full text-white py-2  ${tableHeading[sectionIndex].bgPrimary}`}
                      >
                        <h2 className="text-center ml-10">
                          {/* {tableHeading[sectionIndex].title} */}
                          {"EMPLOYEE SALARY PACKAGE"}
                        </h2>
                      </div>
                      <div className={`flex w-full gap-1 `}>
                        <>
                          {/* <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            SELECT
                          </h3> */}
                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            SL. NO.
                          </h3>
                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            ACTUAL PROFESSION
                          </h3>
                          <h3
                            className={`flex justify-center items-center text-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            VISA PROFESSION
                          </h3>
                          <h3
                            className={`flex justify-center items-center text-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            PROFESSION LEVEL
                          </h3>
                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            GENDER
                          </h3>
                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            NATIONALITY
                          </h3>
                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            QUANTITY
                          </h3>
                          {quotationType === "Cost Plus" ? (
                            propData &&
                            propData[sectionIndex]?.quotation_details?.map(
                              (data, index) => (
                                <h3
                                  className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                                  key={index}
                                >
                                  {data.quotation_heading_name}
                                </h3>
                              )
                            )
                          ) : (
                            <>
                              <h3
                                className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                              >
                                BASIC
                              </h3>
                              <h3
                                className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                              >
                                FOOD
                              </h3>
                              <h3
                                className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                              >
                                FIXED OT
                              </h3>
                              <h3
                                className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                              >
                                HRA
                              </h3>
                              <h3
                                className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                              >
                                TRAVEL ALLOWANCE
                              </h3>
                              <h3
                                className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                              >
                                MOBILE ALLOWANCE
                              </h3>
                              <h3
                                className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                              >
                                AIR TICKET ALLOWANCE
                              </h3>
                              <h3
                                className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                              >
                                ADDITIONAL OT
                              </h3>
                              <h3
                                className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                              >
                                OTHER ALLOWANCE
                              </h3>
                            </>
                          )}
                        </>
                      </div>
                    </>
                  )}
                  <div className="mb-2">
                    {propData?.map((data, index) => (
                      <div
                        className="flex w-full gap-1 relative mb-2 mt-2"
                        key={index}
                      >
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        >
                          {index + 1}
                        </p>
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        >
                          {/* {data.name} */}
                          <select
                            className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                            value={data?.actual_professionId}
                            // onChange={handleVisaChange}
                          >
                            <option>{"select value"}</option>
                            {professions?.Actualprofessions?.map(
                              (data, index) => (
                                <React.Fragment key={index}>
                                  <option value={data.id}>{data.name}</option>
                                </React.Fragment>
                              )
                            )}
                          </select>
                        </p>
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        >
                          <select
                            className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                            value={data?.visa_professionId}
                            // onChange={handleVisaChange}
                          >
                            <option>{"select value"}</option>
                            {professions?.visaProfessions?.map(
                              (data, index) => (
                                <React.Fragment key={index}>
                                  <option value={data.id}>{data.name}</option>
                                </React.Fragment>
                              )
                            )}
                          </select>
                        </p>
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        >
                          {data.profession_level}
                        </p>
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        >
                          {data.gender}
                        </p>
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        >
                          {data.nationality}
                        </p>
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        >
                          {data.quantity}
                        </p>
                        {quotationType === "Cost Plus" ? (
                          data?.quotation_details?.map((filterData, index) => (
                            <h3
                              className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                              key={index}
                            >
                              {filterData.cost}
                            </h3>
                          ))
                        ) : (
                          <>
                            <p
                              className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                            >
                              {quotationType === "Cost Plus"
                                ? "NA"
                                : data.basic}
                            </p>
                            <p
                              className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                            >
                              {quotationType === "Cost Plus" ? "NA" : data.food}
                            </p>
                            <p
                              className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                            >
                              {quotationType === "Cost Plus"
                                ? "NA"
                                : data.fixed_ot}
                            </p>
                            <p
                              className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                            >
                              {quotationType === "Cost Plus" ? "NA" : data.hra}
                            </p>
                            <p
                              className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                            >
                              {quotationType === "Cost Plus"
                                ? "NA"
                                : data.travel_allowance}
                            </p>
                            <p
                              className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                            >
                              {quotationType === "Cost Plus"
                                ? "NA"
                                : data.mobile_allowance}
                            </p>
                            <p
                              className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                            >
                              {quotationType === "Cost Plus"
                                ? "NA"
                                : data.air_ticket_allowance}
                            </p>
                            <p
                              className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                            >
                              {quotationType === "Cost Plus"
                                ? "NA"
                                : data.additional_ot}
                            </p>
                            <p
                              className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                            >
                              {quotationType === "Cost Plus"
                                ? "NA"
                                : data.other_allowance}
                            </p>
                          </>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div style={name2Style}>
          <div className="flex flex-col w-full gap-1 pl-16 mt-5">
            <div className="flex mb-11">
              {QuantityData.map((section, sectionIndex) => (
                <div className="flex flex-col relative" key={sectionIndex}>
                  <div className={`flex w-full gap-1`}>
                    <h3
                      className={`flex justify-center items-center text-sm ${tableHeading2_SUB[sectionIndex].bgSecondary} ${tableProperties2.colWidth} ${tableProperties2.itemHeight}`}
                      style={{ fontSize: "12px" }}
                    >
                      INVOICE SUMMARY
                    </h3>
                    {quotationType === "Cost Plus" ? (
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading2_SUB[sectionIndex].bgSecondary} ${tableProperties2.colWidth} ${tableProperties2.itemHeight}`}
                        style={{ fontSize: "12px" }}
                      >
                        VISA COST QUANTITY
                      </h3>
                    ) : (
                      ""
                    )}
                    <h3
                      className={`flex justify-center items-center text-sm ${tableHeading2_SUB[sectionIndex].bgSecondary} ${tableProperties2.colWidth} ${tableProperties2.itemHeight}`}
                      style={{ fontSize: "12px" }}
                    >
                      SEC DEPOSIT QUANTITY
                    </h3>
                  </div>
                  <div className="mb-2">
                    <div className="flex w-full gap-1 relative mb-2 mt-2">
                      <div className="flex gap-1 absolute"></div>
                      <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties2.colWidth} ${tableProperties2.colHeight}`}
                      >
                        TOTAL INVOICE RAISED
                      </p>
                      {quotationType === "Cost Plus" ? (
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties2.colWidth} ${tableProperties2.colHeight}`}
                        >
                          {invoiceSummary?.visaCostCount
                            ? invoiceSummary?.visaCostCount
                            : 0}
                        </p>
                      ) : (
                        ""
                      )}
                      <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties2.colWidth} ${tableProperties2.colHeight}`}
                      >
                        {invoiceSummary?.totalSecDepositQuantity
                          ? invoiceSummary?.totalSecDepositQuantity
                          : 0}
                      </p>
                    </div>
                    <div className="flex w-full gap-1 relative mb-2 mt-2">
                      <div className="flex gap-1 absolute"></div>
                      <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties2.colWidth} ${tableProperties2.colHeight}`}
                      >
                        TOTAL INVOICE PENDING
                      </p>
                      {quotationType === "Cost Plus" ? (
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties2.colWidth} ${tableProperties2.colHeight}`}
                        >
                          {totalInvoicePending - invoiceSummary?.visaCostCount}
                        </p>
                      ) : (
                        ""
                      )}
                      <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties2.colWidth} ${tableProperties2.colHeight}`}
                      >
                        {totalInvoicePending -
                          invoiceSummary?.totalSecDepositQuantity}
                      </p>
                    </div>
                    <div className="flex w-full gap-1 relative mb-2 mt-2">
                      <div className="flex gap-1 absolute"></div>
                      <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties2.colWidth} ${tableProperties2.colHeight}`}
                      >
                        TOTAL ADDL. INVOICE RAISED
                      </p>
                      {quotationType === "Cost Plus" ? (
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties2.colWidth} ${tableProperties2.colHeight}`}
                        >
                          {totalInvoicePending - invoiceSummary?.visaCostCount <
                          0
                            ? invoiceSummary?.visaCostCount -
                              totalInvoicePending
                            : 0}
                        </p>
                      ) : (
                        ""
                      )}
                      <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties2.colWidth} ${tableProperties2.colHeight}`}
                      >
                        {/* invoiceSummary.totalSecDepositQuantity */}
                        {totalInvoicePending -
                          invoiceSummary?.totalSecDepositQuantity <
                        0
                          ? invoiceSummary?.totalSecDepositQuantity -
                            totalInvoicePending
                          : 0}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
